/**
 * ⭐⭐ **O Fundo de Custas ao lado do "% escrito" — 29/09/2026, pedido do Zion.**
 *
 * > *"Como avisaremos o cliente sobre o limite do fundo de custas, precisa ter
 * > algo visual onde marca a porcentagem atual do fundo de custas do caso."*
 *
 * ⚠️ **Mostra a proporção, nunca o valor:** o colaborador não vê dinheiro. As
 * duas marcas são as da casa: aos **80%** o Hub avisa vocês (ouro), aos **90%**
 * a proposta manda comunicar o cliente (vinho). O teto é o do CASO, não o do
 * contrato (decisão dele, 29/09).
 */
export function PilulaDoFundo({ consumido }: { consumido: number | null | undefined }) {
  if (consumido === undefined) return null;
  if (consumido === null) {
    return (
      <span className="s-pilula s-pilula-quieta rel-fundo" title="O caso ainda não tem o teto do Fundo de Custas. Ele se preenche na tela do Fundo de Custas do caso.">
        Fundo de Custas sem teto
      </span>
    );
  }
  const pct = Math.round(consumido * 100);
  const classe = consumido >= 0.9 ? 's-pilula s-pilula-vinho' : consumido >= 0.8 ? 's-pilula s-pilula-ouro' : 's-pilula';
  const titulo =
    consumido > 1
      ? 'O gasto passou do teto do Fundo de Custas do caso.'
      : consumido >= 0.9
        ? 'Chegou aos 90%: a proposta manda comunicar o cliente e combinar o novo depósito.'
        : consumido >= 0.8
          ? 'Passou dos 80%: prepare a comunicação ao cliente, que é aos 90%.'
          : 'Quanto do teto do Fundo de Custas do caso já foi usado.';
  return (
    <span className={`${classe} rel-fundo`} title={titulo}>
      Fundo de Custas {pct}%
      <i className="rel-fundo-barra" aria-hidden="true">
        <b style={{ width: `${Math.min(pct, 100)}%` }} />
      </i>
    </span>
  );
}
